package com.trevorwiebe.timesheet.core.presentation.common

import kotlinx.browser.window

actual fun openPendingTab(message: String): PendingTab? {
    val tab = window.open("", "_blank") ?: return null
    tab.document.head?.innerHTML = """
        <style>
          html, body { height: 100%; margin: 0; }
          body { display: flex; align-items: center; justify-content: center; background: #fff; }
          @media (prefers-color-scheme: dark) { body { background: #121212; } }
          .spinner { width: 48px; height: 48px; border: 4px solid rgba(128, 128, 128, 0.25);
            border-top-color: #888; border-radius: 50%; animation: spin 0.8s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        </style>
    """.trimIndent()
    tab.document.body?.innerHTML = "<div class=\"spinner\" role=\"progressbar\" aria-label=\"$message\"></div>"
    tab.document.title = message
    tab.focus()
    return object : PendingTab {
        override fun open(url: String) {
            tab.location.href = url
        }

        override fun close() = tab.close()
    }
}
